<div data-cy="family-list-container" *ngFor="let family of familyList; let rowIndex = index">
	<section class="dz-row dz-align-items-center padding-vertical-object-3 family-row" [ngClass]="{ active: accordionState[family.familyId] }">
		<div
			class="dz-col-20 dz-col-lg-4 dz-flex dz-align-self-center mb-family padding-bottom-object-3-md"
			(click)="onToggleAccordion(family)"
			custom-tracking
			[track-event]="
				tealiumConstants.MODELS_EXPERIENCE_EVENTS.MODELS_EXPERIENCE_APP_NAME +
				':' +
				tealiumConstants.MODELS_EXPERIENCE_EVENTS.FIND_AND_COMPARE_PAGE +
				':family list accordion click:' +
				family.subType +
				':' +
				category +
				':' +
				family.familyId +
				':' +
				(accordionState[family.familyId] ? 'hide' : 'show')
			"
		>
			<button data-cy="family-accordion" class="btn-chevron hover-pointer" [class.active]="!!accordionState[family.familyId]" tabindex="-1">
				<dz-icon *ngIf="accordionState[family.familyId]" type="minus" class="color-blk-orange dz-text-14"></dz-icon>
				<dz-icon *ngIf="!accordionState[family.familyId]" type="plus" class="color-blk-orange dz-text-14"></dz-icon>
			</button>
			<div class="margin-left-object-2" *ngIf="family.description?.rawValue">
				<p class="dz-text-16-bold">
					<a [dcrHTMLKey]="'DESCRIPTION_' + family.description?.formattedValue" queryParamsHandling="merge" data-cy="family-name-link">
						<span>
							{{
								groupId !== sharedApplicationConstants.MODEL_FAMILY.BLACKROCK_FAMILY_GROUP && family?.modelExternalName?.formattedValue
									? family?.modelExternalName?.formattedValue
									: family.description
							}}
						</span>
					</a>
				</p>
			</div>
		</div>
		<div class="dz-col-4 dz-hidden-lg dz-block margin-top-object-4 dz-text-align-right">
			<a
				[routerLink]="[appPaths.FAMILY]"
				[queryParams]="{ familyId: family.familyId, groupId, userFilterName }"
				[ngClass]="{ 'disable-public-view': !isAuthenticated }"
				queryParamsHandling="merge"
				custom-tracking
				[track-event]="
					tealiumConstants.MODELS_EXPERIENCE_EVENTS.MODELS_EXPERIENCE_APP_NAME +
					':' +
					tealiumConstants.MODELS_EXPERIENCE_SUB_SUB_SECTION_NAMES.FAMILY_DETAILS +
					':latest holdings:' +
					family.subType +
					':' +
					category +
					':' +
					family.familyId
				"
				data-cy="allocation-insights-link"
			>
				<dz-icon type="chart-pie" class="color-blk-orange dz-text-20"></dz-icon>
			</a>
		</div>
		<div class="dz-col-lg-6 dz-col-sm-24 dz-col-md-24 mb-objective">
			<div *ngIf="family.objective?.rawValue" class="padding-left-object-6-md padding-bottom-object-3-md">
				<div class="dz-col dz-hidden-lg dz-block-md dz-text-md-12-bold dz-text-12">
					<span dcrHTMLKey="OBJECTIVE_HEADER_LABEL">Objective</span>
				</div>
				<p class="cell-header dz-text-14" [dcrHTMLKey]="'OBJECTIVE_' + family.aladdinTicker?.formattedValue">
					<span>{{ family.objective | trim }}</span>
				</p>
			</div>
		</div>
		<div class="dz-col-lg-3 dz-col-md-6 dz-col-sm-10 dz-col-10 mb-vehicle">
			<div *ngIf="family.vehicle?.rawValue" class="padding-left-object-6-md">
				<div class="dz-col dz-hidden-lg dz-block-md dz-text-md-12-bold dz-text-12">
					<span dcrHTMLKey="VEHICLE_HEADER_LABEL">Vehicle</span>
				</div>
				<p class="dz-text-14" [dcrHTMLKey]="'VEHICLE_' + family.vehicle">
					<span>{{ family.vehicle | trim }}</span>
				</p>
			</div>
		</div>
		<div class="dz-col-lg-3 dz-col-md-6 dz-col-sm-14 dz-col-14 mb-trade-freq">
			<div *ngIf="family.tradeFrequency?.rawValue">
				<div class="dz-col dz-hidden-lg dz-block-md dz-text-md-12-bold dz-text-12">
					<span dcrHTMLKey="TRADE_FREQUENCY_HEADER_LABEL">Trade Frequency</span>
				</div>
				<p class="dz-text-14" [dcrHTMLKey]="'TRADEFREQUENCY_' + family.tradeFrequency">
					<!-- Using span to allow html content -->
					<span [innerHTML]="family.tradeFrequency"></span>
				</p>
			</div>
		</div>
		<div class="dz-col-lg-3 dz-col-md-6 dz-col-sm-14 dz-col-14 mb-trade-freq dz-text-align-left dz-text-align-center-md">
			<div class="dz-col dz-hidden-lg dz-block-md dz-text-md-12-bold dz-text-12">
				<span dcrHTMLKey="TRADE_DATE_HEADER_LABEL">Trade Date </span>
			</div>
			<p class="dz-text-14">
				{{ dateFormatter.format(family.asOfDate.formattedValue) }}
			</p>
			<span dcrHTMLKey="TRADE_DATE_COLUMN_SUBTEXT"></span>
		</div>
		<div class="dz-col-lg-5 dz-col-md-12 dz-col-sm-24 dz-col-24 collapse-action dz-align-self-center mb-allocations dz-hidden dz-block-lg">
			<new-feature featureKey="NEW_ALLOCATIONS_INSIGHTS" *ngIf="rowIndex === 0"></new-feature>
			<div class="allocations-container dz-flex dz-align-item-center">
				<icon type="chevron-right" class="cta-link-arrow margin-right-object-1 dz-text-12" aria-hidden="true"></icon>
				<a
					class="dz-text-16-bold"
					dcrHTMLKey="ALLOCATIONS_INSIGHTS_TAB_TEXT"
					[routerLink]="!redirectToACT2 ? [appPaths.FAMILY] : null"
					[queryParams]="{ familyId: family.familyId, groupId, subType: family.subType, userFilterName }"
					[ngClass]="{ 'disable-public-view': !redirectToACT2 && !isAuthenticated }"
					queryParamsHandling="merge"
					custom-tracking
					[track-event]="
						tealiumConstants.MODELS_EXPERIENCE_EVENTS.MODELS_EXPERIENCE_APP_NAME +
						':' +
						tealiumConstants.MODELS_EXPERIENCE_SUB_SUB_SECTION_NAMES.FAMILY_DETAILS +
						':latest holdings:' +
						family.subType +
						':' +
						category +
						':' +
						family.familyId
					"
					data-cy="allocation-insights-link"
					(click)="viewDetails(family.familyId)"
				>
					Holdings, Commentary & Performance
				</a>
			</div>
		</div>
	</section>
	<!-- Open expanded view for Model Family details-->
	<div *ngIf="accordionState[family.familyId]" [@expandCollapseAnimation]="accordionState[family.familyId] ? 'expanded' : 'collapsed'">
		<div
			class="dz-hidden dz-block-md model-list-container"
			[class.no-models]="familyModelsLength[family.familyId] === 0"
			*ngIf="familyIds$[family.familyId]; else loadingSkeleton"
			fadeInAnimation
		>
			<mb-model-list-container
				*componentId="{ componentId: 'me.models.overview', ids: familyIds$[family.familyId] }; let res"
				[data]="res"
				[searchText]="searchText"
				[familyId]="family.familyId.toString()"
				[selectedFilters]="selectedFilters"
				[category]="category"
				[description]="family?.description"
				[modelIdsList]="familyModelsMapping ? familyModelsMapping[family.familyId] : null"
				[familyType]="family.subType.toString()"
				[isAuthenticated]="isAuthenticated"
				[groupId]="groupId"
				[selectedModelsToCompare]="selectedModelsToCompare"
				(selectedModels)="selectedModels.emit($event)"
			></mb-model-list-container>
		</div>
		<div class="padding-top-object-5 dz-hidden-md dz-block dz-text-align-center dz-text-14" dcrHtmlKey="MODEL_LIST_MOBILE_MSG">
			To view this content, please switch to a desktop device
		</div>
		<div class="padding-top-object-5 border-bottom-black"></div>
		<ng-template #loadingSkeleton>
			<mb-model-list-skeleton class="dz-hidden dz-block-md"></mb-model-list-skeleton>
		</ng-template>
	</div>
</div>
<div *ngIf="(familyList | modelsBrowseFilter : selectedFilters : 'portfolios')?.length === 0">
	<mb-model-list-empty-container></mb-model-list-empty-container>
</div>
